//主页面
const index = () => import(/* webpackChunkName:'grounp' */ '@/components/home.vue');

//出库明细详情
const outStockList = () =>
  import(/* webpackChunkName:'grounp' */ '@/pages/productionCenter/outStock/list.vue');

const productionRouter = {
  path: '/production',
  component: index,
  children: [
    {
      path: 'outStockList',
      name: 'outStockList',
      component: outStockList,
      meta: {
        keepAlive: true,
        title: '成品出库明细',
      },
    },
    // {
    //   path: 'rawDataAdd',
    //   name: 'rawDataAdd',
    //   component: rawDataAdd,
    //   meta: {
    //     keepAlive: true,
    //     title: '成品出库新增'
    //   }
    // }
  ],
};
export default productionRouter;
